module.exports = __webpack_public_path__ + "static/media/icsa.5a88d9ca.png";